/**
 * A direct chat stays "pending" until the person it was started with accepts. Messages
 * reach them straight away, under Requests; the sender keeps the chat in their inbox and
 * can keep writing until it's declined.
 */

const idOf = (value) => String(value?._id ?? value ?? "");

/**
 * Where a chat stands as a message request, seen by `userId`: "sent" or "declined" when
 * they started it, "received" or "youDeclined" when it was sent to them, null otherwise.
 */
export function requestState(conversation, userId) {
  if (conversation?.kind === "support" || conversation?.status !== "pending") return null;
  const request = conversation.request;
  if (!request || request.status === "accepted") return null;
  const mine = idOf(request.from) === idOf(userId);
  if (request.status === "rejected") return mine ? "declined" : "youDeclined";
  return mine ? "sent" : "received";
}

/** Inbox chats: everything but requests sent to this user, which wait under Requests. */
export function belongsInInbox(conversation, userId) {
  if (conversation?.status !== "pending") return true;
  const request = conversation.request;
  if (!request) return false;
  return request.status === "accepted" || idOf(request.from) === idOf(userId);
}

/** The chat a message request opened, among the user's conversations. */
export const conversationForRequest = (conversations, request) =>
  conversations.find((c) => c.request && idOf(c.request._id) === idOf(request?._id)) || null;
